import { eventBus } from '@eventBus'
import cSocket from './cSocket'
export default {
    data() {
        return {
            tel_cSocket: null
        }
    },
    methods: {
        tel_initSocket() {

            this.tel_cSocket = new cSocket({
                wss: 'wss://new-8005.fleetsoft.pro',
                token: this.user.token,
                name: '8005',
                onmessage: this.tel_onmessage
            })
            eventBus.$on('socketEmit_tel', this.tel_cSocket.emit.bind(this.tel_cSocket));
        },
        tel_onmessage(action, data) {
            console.log('tel_onmessage:',{action, data})
            switch (action) {
                case 'action_incoming_call':
                    eventBus.$emit('incomingCall', data);
                    break;
                case 'action_end_call':
                    eventBus.$emit('endCall', data);
                    break;
                default:
                    break;
            }
        }
    }
}